const PagenotFound = () => {
  return (
    <div>
    <div class="flex items-center justify-center w-10/12 m-auto">
            <div class="hidden md:flex md:w-1/2 p-8">
                
            </div>
    
                <div class="my-[13rem] w-full md:w-1/2 p-4 md:p-8">
                <h1 class="text-4xl md:text-6xl font-bold dark:text-white text-black mb-4">404 Not Found</h1>
                <p class="text-lg md:text-xl dark:text-[#aeaeae] text-darkGray mb-8">Oops! The page you are looking for could not be found.</p>
                <a href="/" class="px-6 py-3 bg-black text-white rounded-lg inline-block hover:bg-[#171717] transition duration-300 ease-in-out">Go to Home</a>
            </div>
        </div></div>
  )
}

export default PagenotFound